export async function reverseGeocode(
  lat: number,
  lon: number,
): Promise<{ city: string; country: string } | null> {
  try {
    const response = await fetch(
      `https://photon.komoot.io/reverse?lat=${lat}&lon=${lon}`,
    );
    const data = await response.json();

    if (data.features && data.features.length > 0) {
      const props = data.features[0].properties;
      const city = props.city || props.town || props.village || props.name || "";
      const country = props.country || "";
      return { city, country };
    }
  } catch (err) {
    console.error("Reverse geocode error:", err);
  }
  return null;
}

export async function geocode(
  city: string,
  country: string,
): Promise<{ lat: number; lon: number } | null> {
  try {
    const response = await fetch(
      `/geocode?city=${encodeURIComponent(city)}&country=${encodeURIComponent(country)}`,
    );
    if (!response.ok) {
      return null;
    }
    return await response.json();
  } catch (err) {
    console.error("Geocode error:", err);
  }
  return null;
}

export async function fetchCitySuggestions(query: string): Promise<any[]> {
  try {
    const response = await fetch(
      `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=5&layer=city`,
    );
    const data = await response.json();
    return data.features || [];
  } catch (error) {
    console.error("Autocomplete error:", error);
    return [];
  }
}
